import useProductForm from 'hooks/useProductForm'
import { openModal } from 'helpers/dom'

function ProductInfo({ headingTag = 'h1' }) {
  const { initProduct } = useProductForm()
  const HeadingTag = headingTag
  return (
    <div>
      <HeadingTag class="mb-1 text-2xl text-grey-1000 md:text-3xl font-heading">{initProduct.title}</HeadingTag>
      {vendorSettings.products.length > 0 && (
        <p className="mt-1 text-sm capitalize text-grey-700">
          <button
            className="normal-case text-grey-500 link underline-offset-[6px] hover:text-link-hover"
            onClick={() => openModal(vendorSettings.idModal)}
            title={vendorSettings.vendorText}
          >
            {vendorSettings.vendorText}
          </button>
        </p>
      )}
    </div>
  )
}

export default ProductInfo
